import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonToggleSelectModule, CalendarPickerModule } from 'ngx-zcs-components';
import { MatIconModule } from '@angular/material/icon';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { IonicModule } from '@ionic/angular';

import { EnergyDataOverviewComponent } from './energy-data-overview.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    EnergyDataOverviewComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CalendarPickerModule,
    CommonModule,
    IonicModule,
    MatIconModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts/core') })
  ],
  exports: [
    EnergyDataOverviewComponent,
  ],
})
export class EnergyDataOverviewModule { }
